import {useQuery} from "@tanstack/react-query";
import api from "../lib/api";

export function useBusinessDetails(businessId?: string | null) {
    return useQuery({
        queryKey: ["business", businessId],
        enabled: !!businessId,
        queryFn: () => api.get(`/api/v1/business/${businessId}`).then(r => r.data),
        staleTime: 30_000,
        refetchOnWindowFocus: false,
    });
}